import { SERVICE } from '@src/api/types/shared/serviceType';
import CommonHelmet from '@src/components/CommonHelmet';
import { CompanyCommunityGuard, TenantCommunityGuard } from '@src/components/guard/CommunityGuard';
import { useTenantAuth } from '@src/context/auth/useTenantAuth';
import { COMPANY_ROLE } from '@src/enum/companyRoleEnum';
import { TENANT_ROLE } from '@src/enum/tenantRoleEnum';
import CommunityMemberShow from '@src/features/shared/community/CommunityMemberShow';
import CommunityDefaultLayout from '@src/layouts/shared/CommunityDefaultLayout';
import Error404 from '@src/pages/Error404';
import { COMMUNITY_MEMBERS_DETAIL_MODE } from '@src/utils/channelMember';

export type CommunityMembersDetailProps = {
  mode: 'tenant' | 'company';
};

function CommunityMembersDetail(prop: CommunityMembersDetailProps) {
  const tenantAuth = useTenantAuth();
  if (!tenantAuth.profile) {
    return null;
  }
  if (
    ![COMMUNITY_MEMBERS_DETAIL_MODE.COMPANY, COMMUNITY_MEMBERS_DETAIL_MODE.TENANT].includes(
      prop.mode,
    )
  ) {
    return <Error404 isTenant={tenantAuth.profile?.isLogin ?? false} />;
  }
  const isAdmin = !!tenantAuth.profile?.user?.isAdmin;

  return (
    <>
      {tenantAuth.profile?.isLogin ? (
        <TenantCommunityGuard
          canRoles={[TENANT_ROLE.ADMIN, TENANT_ROLE.CONTENT, TENANT_ROLE.MEMBER]}
          canService={[SERVICE.ONLINE_COMMUNITY]}
          checkAuthenticate={true}
          checkAccessibleNotPublicChannel={!isAdmin}
        >
          <CommunityDefaultLayout>
            <CommonHelmet />
            <CommunityMemberShow mode={prop.mode} />
          </CommunityDefaultLayout>
        </TenantCommunityGuard>
      ) : (
        <CompanyCommunityGuard
          canRoles={[COMPANY_ROLE.ADMIN, COMPANY_ROLE.USER]}
          canService={[SERVICE.ONLINE_COMMUNITY]}
          checkAuthenticate={true}
          checkAccessibleNotPublicChannel={true}
        >
          <CommunityDefaultLayout>
            <CommonHelmet />
            <CommunityMemberShow mode={prop.mode} />
          </CommunityDefaultLayout>
        </CompanyCommunityGuard>
      )}
    </>
  );
}

export default CommunityMembersDetail;
